import { mapState, mapGetters } from "vuex";

export default () => {
  return {
    computed: {
      ...mapState("account", {
        shopInfo: "shopInfo"
      }),
      ...mapState("downgrade", {
        pagesPublishCount: state => state.pagesPublishCount
      }),
      ...mapGetters("downgrade", {
        isNeedToUnpublishProductPage: "isNeedToUnpublishProductPage",
        isNeedToUnpublishArticlePage: "isNeedToUnpublishArticlePage"
      }),
      // TODO: recheck with shop mixed
      isNeedToUnpublishProduct() {
        const publishedCount = this.publishedCount('publishedProductPagesCount');

        return this.isNeedToUnpublishProductPage(publishedCount);
      },
      isNeedToUnpublishArticle() {
        const publishedCount = this.publishedCount('publishedArticlePagesCount');
        return this.isNeedToUnpublishArticlePage(publishedCount);
      }
    },
    methods: {
      publishedCount(key) {
        const { isGemPagesV6, isGemPagesV7, isGemPagesMixed } = this.shopInfo.shopType;

        if (isGemPagesV6) return this.shopInfo[key];
        if (isGemPagesV7) return this.pagesPublishCount[key];
        if (isGemPagesMixed) return this.pagesPublishCount[key] +  this.shopInfo[key];

        return 0;
      },
    }
  };
};
